import HTMLContent from './html-content-container'
export default HTMLContent
